import {
  checkNull,
  KeyValPair,
  ListContent,
  ReportContainer,
} from "../constant";

interface RosBlockProps {
  data: any;
}

const RosBlock = ({ data }: RosBlockProps) => {
  if (!checkNull(data?.rosTemplates)) return null;

  return (
    <ReportContainer label="Review of Systems">
      <ListContent
        list={data?.rosTemplates}
        renderItem={(item) => (
          <KeyValPair k={item?.templateNameType} v={item?.description} />
        )}
      />
    </ReportContainer>
  );
};

export default RosBlock;
